/**
 * @desc In order to create the TimeDropdown we need to store
 * time cannonical values to be used later inside data-time
 * @return number[] [0, 15, 30, 45, ...etc]
 */
function createTimeCannonical() {
  let time = 0;
  const timeCannonical: number[] = [];
  const timeToReach = 1425;
  const timeIncreased = 15;
  while (time <= timeToReach) {
    timeCannonical.push(time);
    time += timeIncreased;
  }

  return timeCannonical;
}

const timesCreated = createTimeCannonical();
export const timesCannonical = timesCreated;
